import { gql } from "@apollo/client";

import { COLLEGE_CERTIFICATE_FIELDS } from "../queries/collegeCertificates";

export const CREATE_COLLEGE_CERTIFICATE = gql`
  mutation CreateCollegeCertificate($input: UpdateCollegeCertificateInput!) {
    createCertCollegeCertificate(input: $input) {
      ...CollegeCertificateFields
    }
  }
  ${COLLEGE_CERTIFICATE_FIELDS}
`;

export const UPDATE_COLLEGE_CERTIFICATE = gql`
  mutation UpdateCollegeCertificate(
    $id: ID!
    $input: UpdateCollegeCertificateInput!
  ) {
    updateCertCollegeCertificate(id: $id, input: $input) {
      ...CollegeCertificateFields
    }
  }
  ${COLLEGE_CERTIFICATE_FIELDS}
`;

export const DELETE_COLLEGE_CERTIFICATE = gql`
  mutation DeleteCollegeCertificate($id: ID!) {
    deleteCertCollegeCertificate(id: $id) {
      id
    }
  }
`;
